import * as React from 'react';
import Overview from '../overview';
import SectionTitle from '../_common/section-title';
import DatasetImageSection from '../dataset-image-section';
import { ReactComponent as OverviewIcon } from '../../assets/svg/icons/overview.svg';
import { getText, getConfig } from '../../helpers';

const Carousel = React.lazy(() => import('../_common/carousel'));

const title = getText('pages.dataset.overviewTitle');
const pageOf = getText('generic.pageOf');
const bundleOptions = getConfig('routes.dataset.carouselOptions');
const initialCarouselState = getConfig('routes.dataset.initialCarouselState');

const datasetOverviewSection = function DatasetOverviewSection({ dataset, scrollTo, isBundle }: DatasetOverviewSectionProps) {

    const linkedDatasets = dataset.bundleDatasets || [];

    const [carouselState, updateCarouselState] = React.useState<{ activeSlide: number; totalSlides: number }>(initialCarouselState);

    React.useEffect(() => {
        updateCarouselState({ activeSlide: 1, totalSlides: linkedDatasets.length });
    }, [dataset]);

    const carouselOptions = {
        ...bundleOptions,
        lazyLoad: false,
        beforeChange: (active: number, next: number) => {
            updateCarouselState(state => {
                return { ...state, activeSlide: next + 1 };
            });
        }
    };

    const bundleCarousel = (
        <div className="page-section__inner--carousel">
            <Carousel carouselSettings={carouselOptions}>
                {linkedDatasets.map((linkedDataset: DataProfile, index: number) => (
                    <div key={linkedDataset.name}>
                        <div className="page-section__inner" data-testid={`bundle-carousel-overview-${index}`}>
                            <Overview dataProfile={linkedDataset} isBundled />
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );

    const noBundle = (
        <div className="page-section__inner">
            <Overview dataProfile={dataset} />
        </div>
    );

    return (
        <section id="dataset-overview" className="dataset-overview-section">
            <div className="page-section background-color-white-smoke border-bottom">
                <div className="page-section__inner">
                    <SectionTitle
                        hash="dataset-overview"
                        text={title}
                        subText={carouselState.totalSlides > 0 ? <span>{`${carouselState.activeSlide} ${pageOf} ${carouselState.totalSlides}`}</span> : null}
                        icon={<OverviewIcon />}
                        onClick={scrollTo}
                    />
                </div>
                {isBundle ? bundleCarousel : noBundle}
            </div>
            <DatasetImageSection dataset={dataset} isBundle={dataset.isBundle} />
        </section>
    );
};

export default React.memo(datasetOverviewSection);
